import React from 'react';

import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';

import ServiceFailureView from '../Views/TO/Reset/ServiceFailureView.js';
const appVars = AppVars.getInstance()
const logger = Logger.getInstance();

class ServiceFailure extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
    }
} 

    render(){
        return(
           <ServiceFailureView style = {this.props.style}/>



          
    );

    }

}




export default ServiceFailure;